// extracted by mini-css-extract-plugin
export default {"tooltip":"zo-z","sharingV2":"Ao-z","sharingIconsV2":"Bo-z","links":"Co-z","link":"Do-z","facebookV2":"Eo-z","twitterV2":"Fo-z","pinterestV2":"Go-z"};